// File size limits in bytes
export const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB (the backend has no defined limit., but we set one for UX purposes)

export const ALLOWED_FILE_TYPES = [
  'application/pdf', // .pdf
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'text/plain', // .txt
  'text/csv', // .csv
]

export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.txt', '.csv']

export const S3_SUCCESS_STATUS_CODES = {
  MIN: 200,
  MAX: 299,
}
